/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function PMScheduleFromJSON(json) {
    return PMScheduleFromJSONTyped(json, false);
}
export function PMScheduleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'pMschedID': !exists(json, 'pMschedID') ? undefined : json['pMschedID'],
        'propertyID': !exists(json, 'propertyID') ? undefined : json['propertyID'],
        'pmSchedNum': !exists(json, 'pmSchedNum') ? undefined : json['pmSchedNum'],
        'orderBy': !exists(json, 'orderBy') ? undefined : json['orderBy'],
        'dept': !exists(json, 'dept') ? undefined : json['dept'],
        'phoneNum': !exists(json, 'phoneNum') ? undefined : json['phoneNum'],
        'jobType': !exists(json, 'jobType') ? undefined : json['jobType'],
        'assignTo': !exists(json, 'assignTo') ? undefined : json['assignTo'],
        'vendorID': !exists(json, 'vendorID') ? undefined : json['vendorID'],
        'assetIDList': !exists(json, 'assetIDList') ? undefined : json['assetIDList'],
        'location1': !exists(json, 'location1') ? undefined : json['location1'],
        'floor': !exists(json, 'floor') ? undefined : json['floor'],
        'location2': !exists(json, 'location2') ? undefined : json['location2'],
        'location3': !exists(json, 'location3') ? undefined : json['location3'],
        'jobPriority': !exists(json, 'jobPriority') ? undefined : json['jobPriority'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'entryDate': !exists(json, 'entryDate') ? undefined : (json['entryDate'] === null ? null : new Date(json['entryDate'])),
        'entryTime': !exists(json, 'entryTime') ? undefined : json['entryTime'],
        'originalOrderNum': !exists(json, 'originalOrderNum') ? undefined : json['originalOrderNum'],
        'estimatedHours': !exists(json, 'estimatedHours') ? undefined : json['estimatedHours'],
        'scheduledStartDate': !exists(json, 'scheduledStartDate') ? undefined : (json['scheduledStartDate'] === null ? null : new Date(json['scheduledStartDate'])),
        'scheduledStartTime': !exists(json, 'scheduledStartTime') ? undefined : json['scheduledStartTime'],
        'targetCompleteNumDays': !exists(json, 'targetCompleteNumDays') ? undefined : json['targetCompleteNumDays'],
        'repeatNumPeriods': !exists(json, 'repeatNumPeriods') ? undefined : json['repeatNumPeriods'],
        'repeatPeriodType': !exists(json, 'repeatPeriodType') ? undefined : json['repeatPeriodType'],
        'repeatEndDate': !exists(json, 'repeatEndDate') ? undefined : (json['repeatEndDate'] === null ? null : new Date(json['repeatEndDate'])),
        'lastRepeatDate': !exists(json, 'lastRepeatDate') ? undefined : (json['lastRepeatDate'] === null ? null : new Date(json['lastRepeatDate'])),
        'cNextRepeatDateWeekendCheck': !exists(json, 'cNextRepeatDateWeekendCheck') ? undefined : (json['cNextRepeatDateWeekendCheck'] === null ? null : new Date(json['cNextRepeatDateWeekendCheck'])),
        'cNextRepeatDate': !exists(json, 'cNextRepeatDate') ? undefined : (json['cNextRepeatDate'] === null ? null : new Date(json['cNextRepeatDate'])),
        'cRepeatBaseDate': !exists(json, 'cRepeatBaseDate') ? undefined : (json['cRepeatBaseDate'] === null ? null : new Date(json['cRepeatBaseDate'])),
        'cRepeatEndDisplay': !exists(json, 'cRepeatEndDisplay') ? undefined : json['cRepeatEndDisplay'],
        'cLastRepeatDisplay': !exists(json, 'cLastRepeatDisplay') ? undefined : json['cLastRepeatDisplay'],
        'cFloatingTypeId': !exists(json, 'cFloatingTypeId') ? undefined : json['cFloatingTypeId'],
        'pmLinkOption': !exists(json, 'pmLinkOption') ? undefined : json['pmLinkOption'],
        'cPMorderNum': !exists(json, 'cPMorderNum') ? undefined : json['cPMorderNum'],
        'cPMSetupTypeDisplay': !exists(json, 'cPMSetupTypeDisplay') ? undefined : json['cPMSetupTypeDisplay'],
        'procedurename': !exists(json, 'procedurename') ? undefined : json['procedurename'],
        'supersedesOrder': !exists(json, 'supersedesOrder') ? undefined : json['supersedesOrder'],
    };
}
export function PMScheduleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'pMschedID': value.pMschedID,
        'propertyID': value.propertyID,
        'pmSchedNum': value.pmSchedNum,
        'orderBy': value.orderBy,
        'dept': value.dept,
        'phoneNum': value.phoneNum,
        'jobType': value.jobType,
        'assignTo': value.assignTo,
        'vendorID': value.vendorID,
        'assetIDList': value.assetIDList,
        'location1': value.location1,
        'floor': value.floor,
        'location2': value.location2,
        'location3': value.location3,
        'jobPriority': value.jobPriority,
        'description': value.description,
        'notes': value.notes,
        'entryDate': value.entryDate === undefined ? undefined : (value.entryDate === null ? null : value.entryDate.toISOString()),
        'entryTime': value.entryTime,
        'originalOrderNum': value.originalOrderNum,
        'estimatedHours': value.estimatedHours,
        'scheduledStartDate': value.scheduledStartDate === undefined ? undefined : (value.scheduledStartDate === null ? null : value.scheduledStartDate.toISOString()),
        'scheduledStartTime': value.scheduledStartTime,
        'targetCompleteNumDays': value.targetCompleteNumDays,
        'repeatNumPeriods': value.repeatNumPeriods,
        'repeatPeriodType': value.repeatPeriodType,
        'repeatEndDate': value.repeatEndDate === undefined ? undefined : (value.repeatEndDate === null ? null : value.repeatEndDate.toISOString()),
        'lastRepeatDate': value.lastRepeatDate === undefined ? undefined : (value.lastRepeatDate === null ? null : value.lastRepeatDate.toISOString()),
        'cNextRepeatDateWeekendCheck': value.cNextRepeatDateWeekendCheck === undefined ? undefined : (value.cNextRepeatDateWeekendCheck === null ? null : value.cNextRepeatDateWeekendCheck.toISOString()),
        'cNextRepeatDate': value.cNextRepeatDate === undefined ? undefined : (value.cNextRepeatDate === null ? null : value.cNextRepeatDate.toISOString()),
        'cRepeatBaseDate': value.cRepeatBaseDate === undefined ? undefined : (value.cRepeatBaseDate === null ? null : value.cRepeatBaseDate.toISOString()),
        'cRepeatEndDisplay': value.cRepeatEndDisplay,
        'cLastRepeatDisplay': value.cLastRepeatDisplay,
        'cFloatingTypeId': value.cFloatingTypeId,
        'pmLinkOption': value.pmLinkOption,
        'cPMorderNum': value.cPMorderNum,
        'cPMSetupTypeDisplay': value.cPMSetupTypeDisplay,
        'procedurename': value.procedurename,
        'supersedesOrder': value.supersedesOrder,
    };
}
